export const plannerApiVersion = '1'

export class ClientIncompatibleError extends Error {
  constructor(message = 'This app version is no longer supported.') {
    super(message)
    this.name = 'ClientIncompatibleError'
  }
}

export function plannerApiUrl(path: string): string {
  const url = new URL(path, 'https://meet-halfway.invalid')
  url.searchParams.set('apiVersion', plannerApiVersion)
  return `${url.pathname}${url.search}`
}

export async function plannerApiPayload<T extends { error?: string; code?: string }>(response: Response): Promise<T> {
  const payload = await response.json() as T
  if (response.status === 409 && payload.code === 'client_incompatible') {
    window.dispatchEvent(new Event('planner-api-incompatible'))
    throw new ClientIncompatibleError(payload.error)
  }
  return payload
}

export function isClientIncompatible(cause: unknown): cause is ClientIncompatibleError {
  return cause instanceof ClientIncompatibleError
}
